var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('audio',{ref:"tipAudio",staticStyle:{"visibility":"hidden"},attrs:{"preload":"auto"}},[_c('source',{attrs:{"src":_vm.tipAudioSrc,"type":"audio/wav"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }